module.exports = __webpack_public_path__ + "static/media/05.c3a52469.png";